import React, { useState } from "react";
import axios from "axios";
import { useDispatch } from 'react-redux';
import { translate } from '../../../functions/dictionary.js';
import { jednostki } from '../../../functions/jednostki.js';
import { dataFormat } from "../../../functions/dataFormat.js";
import { objIsNotEmpty } from "../../../functions/utilities.js";
import { faPencil, faChevronLeft, faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { dropdownOptions} from './WspolnotyStawkiAddFormListy.js';
import WspolnotyStawkiListaWszystkich from "./WspolnotyStawkiListaWszystkich.js";
import { fetchStawki } from "../../../Redux/Actions.js";


const WspolnotyStawkiLista = props => {

  const { idw, stawkiAkt, setStawkiAkt, tablica, stawkiArch } = props;

  const [edit, setEdit] = useState(undefined);

  const handleEdit = ( el) => {
    setEdit({
      id: stawkiAkt.id,
      klucz: el.klucz,
      wartosc: el.wartosc,
      rodzaj: el.odpowiednikRodzaj
    })
  } 

  const dispatch = useDispatch();

  const handleCancel = () => setEdit(undefined);

  const handleChange = e => setEdit( prevState => ({...prevState, wartosc: e.target.value}));
  
  const listaRozwijana = () => {
    const opcje = dropdownOptions?.map( (r, i) => {
      return (
        <option key={i} value={r.value} >
          {r.key}
        </option>
      )
    })
    const handle = e => {setEdit( prevState => ({...prevState, rodzaj: e.target.value}))}
    return (
      <select value={edit.rodzaj} onChange={handle}>
        {opcje}
      </select>
    )
  }

  const lista = objIsNotEmpty(stawkiAkt) && tablica?.map((el,i) => {
   
    if (el?.klucz !== "data_od" && el?.klucz !== "id" && el?.klucz !== "id_wspolnoty" && el?.odpowiednikRodzaj2 == "1") {

      if (edit && edit.klucz === el.klucz) {
        return (
          <li key={i}> 
            <div className="klucz">
              {translate(el?.klucz)}
            </div>
            <div className="wartosc">
              <input 
                value={edit.wartosc}
                type="number"
                onChange={handleChange}
              />
            </div>
            <div className="jednostka">
              {listaRozwijana()}
            </div>
            <div className="ikona">
              <FontAwesomeIcon 
                icon={faChevronLeft} 
                onClick={handleCancel}
              />
              <FontAwesomeIcon 
                icon={faCheck} 
                onClick={()=>handleSave(el)}
              />
            </div>
          </li>
        ) 
      } else {
        return (
          <li key={i}> 
            <div className="klucz">
              {translate(el?.klucz)}
            </div>
            <div className="wartosc">
              {el?.wartosc + " zł" }
            </div>
            <div className="jednostka">
              {jednostki(el?.odpowiednikRodzaj)}
            </div>
            <div className="ikona">
              <FontAwesomeIcon 
                icon={faPencil} 
                onClick={()=>handleEdit(el)}
              />
            </div>
          </li>
        )

      }

    }
  });

  const rozliczanieWody = (rodzaj) => {
    switch (rodzaj) {
      case "1":
        return "prosty";
      case "2":
        return "złożony";
      default:
        return "brak informacji"
    }
  }

  const wartosc = tablica && tablica?.length > 0 ? rozliczanieWody(tablica[tablica?.findIndex( el => el.klucz === "rozliczanie_wody")]?.wartosc) : "obliczam..."; 

  const handleSave = async el => {
    await axios.post('/api/stawki_wspolnot_arch/edytuj/', {
        id: edit.id,
        klucz: el.klucz,
        wartosc: edit.wartosc,
        rodzaj: edit.rodzaj
      }).then( (res) => {
        setEdit(undefined);
        dispatch(fetchStawki(idw)); 
      }).catch( err => {
        console.log(err);
      })
  }

  return (
    <div className="stawkiContainer">
      <h3>
        Data obowiązywania od: {
          objIsNotEmpty(stawkiAkt)
          ? dataFormat(stawkiAkt?.data_od) 
          : "-"}
      </h3>
      <div className="listy">
        <div className="lista">
          <ul className="lista stawki">
            <li key={0}>
              <div>Składnik</div>
              <div>Stawka</div>
              <div>Jednostka</div>
              <div className="ikona"></div>
            </li>
            {lista}
          </ul>

          <ul className="lista stawki">
            <li key={0}><div>Rozliczanie wody:</div><div>{wartosc}</div><div></div></li>
          </ul>

          {/* <h5>Dodakotwe koszty per mieszkaniec: { stawkiAkt?.dodatkowy_koszt_1_opis == null && stawkiAkt?.dodatkowy_koszt_2_opis == null ? " brak" : ""} </h5>

          <ul className="lista stawki">
            {
              stawkiAkt?.dodatkowy_koszt_1_opis && (
                <li key={1}><div className="klucz">{stawkiAkt?.dodatkowy_koszt_1_opis}</div><div className="wartosc">{stawkiAkt?.dodatkowy_koszt_1_kwota + " zł"}</div><div className="jednostka"></div></li>
              ) 
            }
            {
              stawkiAkt?.dodatkowy_koszt_2_opis && (
                <li key={2}><div className="klucz">{stawkiAkt?.dodatkowy_koszt_2_opis}</div><div className="wartosc">{stawkiAkt?.dodatkowy_koszt_2_kwota + " zł"}</div><div className="jednostka"></div></li>
              )
            }
          </ul> */}

        </div>
        <WspolnotyStawkiListaWszystkich
          stawkiArch={stawkiArch}
          setStawkiAkt={setStawkiAkt}
          idw={idw}
        />
      </div>
    </div>
  )
}

export default WspolnotyStawkiLista;